webpackJsonp([275328729791212],{

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _styledComponents = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  font-family: 'Yesteryear', cursive, sans-serif;\n  width: max-content;\n  position: relative;\n\n  /* font-weight: bold; */\n\n  &::after {\n    content: '\uD83D\uDD25';\n    position: absolute;\n    right: 0;\n    transform-origin: top right;\n    transform: translate(30%, 23%) scale(0.5) rotate(30deg);\n    z-index: -1;\n  }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents.default.div(_templateObject(), function (props) {
	  return props.size;
	});
	
	var Logo = function Logo(_ref) {
	  var size = _ref.size;
	  return _react.default.createElement(Wrapper, {
	    size: size || 40
	  }, "flamb\xE9");
	};
	
	var _default = Logo;
	exports.default = _default;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  padding: 10px;\n  margin-bottom: 70vh;\n\n  li {\n    margin-bottom: 10px;\n  }\n  a {\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  a:visited {\n    color: rebeccapurple;\n  }\n  h1 {\n    display: inline;\n    color: ', ';\n    font-size: 1em;\n  }\n  p {\n    display: inline;\n    color: #888;\n    font-family: monospace;\n    font-size: 1em;\n  }\n\n  .draft {\n    font-family: monospace;\n    margin-right: 1em;\n    font-size: 1.5em;\n    position: absolute;\n    transform: rotate(-3deg);\n    pointer-events: none;\n\n    span {\n      display: inline-block;\n    }\n  }\n\n  .overlay {\n    position: sticky;\n    z-index: 100000;\n    top: 0;\n\n    &::after {\n      pointer-events: none;\n      content: \'\';\n      position: absolute;\n      height: 100vh;\n      width: 100vw;\n      background: linear-gradient(white,  transparent, 10%, transparent 90%, white)\n    }\n  }\n'], ['\n  list-style: none;\n  padding: 10px;\n  margin-bottom: 70vh;\n\n  li {\n    margin-bottom: 10px;\n  }\n  a {\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n  a:visited {\n    color: rebeccapurple;\n  }\n  h1 {\n    display: inline;\n    color: ', ';\n    font-size: 1em;\n  }\n  p {\n    display: inline;\n    color: #888;\n    font-family: monospace;\n    font-size: 1em;\n  }\n\n  .draft {\n    font-family: monospace;\n    margin-right: 1em;\n    font-size: 1.5em;\n    position: absolute;\n    transform: rotate(-3deg);\n    pointer-events: none;\n\n    span {\n      display: inline-block;\n    }\n  }\n\n  .overlay {\n    position: sticky;\n    z-index: 100000;\n    top: 0;\n\n    &::after {\n      pointer-events: none;\n      content: \'\';\n      position: absolute;\n      height: 100vh;\n      width: 100vw;\n      background: linear-gradient(white,  transparent, 10%, transparent 90%, white)\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _logo = __webpack_require__(74);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _colors = __webpack_require__(25);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var UL = _styledComponents2.default.ul(_templateObject, _colors2.default.accent1);
	
	var PostList = function (_Component) {
	  _inherits(PostList, _Component);
	
	  function PostList() {
	    _classCallCheck(this, PostList);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PostList.prototype.componentDidMount = function componentDidMount() {
	    // this.props.clear();
	  };
	
	  PostList.prototype.render = function render() {
	    return _react2.default.createElement(
	      UL,
	      null,
	      _react2.default.createElement('div', { className: 'overlay' }),
	      this.props.posts.map(function (post) {
	        var isDraft = post.node.fileAbsolutePath.includes('/drafts/');
	        return _react2.default.createElement(
	          'li',
	          { key: post.node.frontmatter.path },
	          isDraft && _react2.default.createElement(
	            'span',
	            { className: 'draft' },
	            'Draft',
	            ' ',
	            _react2.default.createElement(
	              'span',
	              {
	                style: {
	                  transform: 'rotate(' + (-0.15 + 0.3 * Math.random()) + 'turn)'
	                }
	              },
	              '\uD83D\uDE48'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              href: {
	                /** ⚠️ is this (pathname) right 👇?? */
	                pathname: '/blog',
	                query: { slug: post.slug }
	              },
	              to: '/' + post.node.frontmatter.path
	            },
	            _react2.default.createElement(
	              'h1',
	              {
	                style: {
	                  opacity: isDraft ? 0.25 : '' + (post.node.wordCount.words / 200 / 10 + 0.5),
	                  fontSize: isDraft ? '1em' : post.node.wordCount.words / 200 / 2 + 0.5 + 'em'
	                }
	              },
	              post.node.frontmatter.title
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            'p',
	            null,
	            post.node.frontmatter.date
	          )
	        );
	      })
	    );
	  };
	
	  return PostList;
	}(_react.Component);
	
	exports.default = PostList;
	module.exports = exports['default'];

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/** 🔮 might want to have this stored in redux store for theming... but also keep in mind css custom properties... maybe redux would set the custom properties... to persist user preference */
	exports.default = {
	  accent1: 'firebrick',
	  highlight: '#fbf99a',
	  link: '#0066c0'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/astronaut-pushing.f4be9038.svg";

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: 50rem;\n\n  p {\n    text-align: right;\n  }\n  \n'], ['\n  margin: 0 auto;\n  max-width: 50rem;\n\n  p {\n    text-align: right;\n  }\n  \n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(93);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostList = __webpack_require__(151);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	var _astronautPushing = __webpack_require__(273);
	
	var _astronautPushing2 = _interopRequireDefault(_astronautPushing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Main = _styledComponents2.default.main(_templateObject);
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.componentDidMount = function componentDidMount() {
	    /* ⚠️ not working. Just fucking think about it for a second and figure it out! 🤯 */
	    // setTimeout(() => document.body.animate({ scrollTop: document.body.scrollHeight }, 200), 1000)
	    // setTimeout(() => window.scrollTo({top: document.body.scrollHeight}), 1000);
	
	    /* **************☝️**************    */
	
	  };
	
	  BlogIndex.prototype.render = function render() {
	    /* ⚠️ not working */
	    // window.scrollTo({top: document.body.scrollHeight});
	    // document.body.animate({ scrollTop: document.body.scrollHeight }, 200)
	    /***************☝️***********************************/
	    /* I kinda like some kind of visual markup like this*/
	
	    var posts = (0, _get2.default)(this, 'props.data.allWhoa.edges');
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'David Baker is Scribbling' }),
	      _react2.default.createElement(
	        Main,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'I probably wouldn\'t read any of this if I were you. But if I were to find myself here for the first time, I might ',
	          _react2.default.createElement(
	            'a',
	            { href: './moving-through-space-and-time' },
	            'start from the beginning'
	          ),
	          ' to catch up.'
	        ),
	        _react2.default.createElement(_PostList2.default, { posts: posts })
	      ),
	      _react2.default.createElement('img', {
	        className: 'marginal marginal-right',
	        src: _astronautPushing2.default,
	        alt: 'Astronaut',
	        style: {
	          position: 'fixed',
	          transform: 'scalex(-1)',
	          bottom: 0,
	          right: 0
	        }
	      })
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-scribbling-js-2ca7e3f50655cb28b89e.js